export default "__VITE_ASSET__B970B74___"